import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// import Awardslist from "../studentGrid/sublist/awardslist";
import GlobalStudentActivityReportList from '../../pages/common/globalstudentactivityreportlist';
import GlobalStudentAwardsList from '../../pages/common/globalstudentawardlist';
import GlobalStudentActivityList from '../../pages/common/globalstudentactivitylist';
import { useAuth } from '../../../usercontext';
import { Tab, Nav } from 'react-bootstrap';
import GlobalStudentAwardsReportList from '../../pages/common/globalstudentawardsreportlist'

const StudentActivitiesAndAwardsList = () => {
	let { slug } = useParams()
	const { profile } = useAuth()
	const studentId = profile.id
	const [activeTab, setActiveTab] = useState('studendtactivities')

	useEffect(() => {
		const handleTabChange = (eventKey) => {
			setActiveTab(eventKey)
		}
	}, [studentId])

	return (
		<div>
			<Tab.Container defaultActiveKey="programdetails" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
				<Nav variant="tabs">
					<Nav.Item>
						<Nav.Link eventKey="studendtactivities">Student Activities</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link eventKey="studentActivityReports">Student Activity Reports</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link eventKey="studentawards">Student Awards</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link eventKey="studentAwardsReport">Student Awards Report</Nav.Link>
					</Nav.Item>
				</Nav>
				<Tab.Content>
					<Tab.Pane eventKey="studentawards">
						<GlobalStudentAwardsList slug={studentId} isStudent={true} studentRole={profile?.role} />
					</Tab.Pane>
					<Tab.Pane eventKey="studentActivityReports">
						<GlobalStudentActivityReportList studentId={studentId} />
					</Tab.Pane>
					<Tab.Pane eventKey="studendtactivities">
						<GlobalStudentActivityList slug={studentId} isStudent={true} studentRole={profile?.role} />
					</Tab.Pane>
					<Tab.Pane eventKey="studentAwardsReport">
						<GlobalStudentAwardsReportList studentId={studentId} />
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</div>
	)
}

export default StudentActivitiesAndAwardsList;
